import React from 'react';
import CarouselForm from './CarouselForm';
export default function AddCarousel() {
  return <CarouselForm />;
}
